import script from "./BaseEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseEmpty.vue?vue&type=script&setup=true&lang=js"

import "./BaseEmpty.vue?vue&type=style&index=0&id=64adb2df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64adb2df"]])

export default __exports__